// Carosello della Home page con gli immibili visibili in home

import { Component, OnInit, ElementRef, Inject } from '@angular/core';
import { FillerService } from '../../common/Service_tnFiller';



@Component({
  selector: 'tn-ads-list',
  templateUrl: '../../themes/default/html/tnadslist.component.html',
  styleUrls: ['../../themes/default/css/tnadslist.component.scss'],
  providers: []
})

export class TnadslistComponent implements OnInit {

  defaultSchema  = {
      limit: 0,
      offset: 0,
      codes: [],
      buildFloorsPlusThen: 0,
      listKind: "HomeVisible",
      adsIDs: [],
      categoryId: 0,
      groupId: 0,
      typeId: 0,
      rentKindId: 0,
      cityName: "",
      cityZoneId: 0,
      conditioner: false,
      garage: false,
      garden: false,
      animalAdmit: false,
      balcony: false,
      bathroomsPlusThan: 0,
      buildable: false,
      carParkPlusThan: 0,
      lift: false,
      panoramic: false,
      priceRange: [],
      radiators: false,
      roomsPlusThan: 0,
      surfaceRange: [],
      orderByKind: "Id",
      orderByDir: "ASC",
      uiCulture: "it"
  };

  private initdone = false;
  private referencecreated = false;
  private listfilled = false;

  public HomeAd = {
    Property: "Le nostre proposte" 
  }

  constructor(@Inject(Window) private _window: Window, private elementRef:ElementRef, private filler: FillerService) { 

  }

  ngOnInit() {
    if (this.listfilled==true) { return }
    this.UpdateFiller();
  }

  
  CreateReference() {

      var s;
      try {
          s = document.createElement("script");
      } catch (e) {
          return;
      }
      //s.id = "SwipererBig";
      s.type = "text/javascript";
      s.src="./assets/script.js";
      this.elementRef.nativeElement.appendChild(s);
      
      this.initdone = true;
      if (this.initdone) { return; }

  }

  UpdateFiller() {
    new Promise((resolve, reject) => {
      this.filler.Get_AdsList(this.defaultSchema).subscribe(
          data => {
            this.defaultSchema = Object.assign([], data);
            this.listfilled=true;
            resolve(true);
          }, err => { console.log(err) }
        );
    }).then(
      e => this.CreateReference()
    );
    
  }

}



// WEBPACK FOOTER //
// A:/Work/Siti/Volpe2/src/app/components/tnadslist/tnadslist.component.ts